import { NgModule, inject } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthGuard, LanguagesResolver, CountriesResolver, TimezonesResolver } from '@ubie/core';
import { ProductionRedirectComponent } from './production-redirect/production-redirect.component';

const routes: Routes = [
  { path: '', redirectTo: 'tabs/dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
    resolve: { languages: LanguagesResolver },
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterPageModule),
    resolve: { countries: CountriesResolver },
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
  },
  {
    path: 'reset/:id',
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
  },
  {
    path: 'activate/:id',
    loadChildren: () => import('./activate/activate.module').then(m => m.ActivatePageModule)
  },
  {
    path: 'accept/:id',
    loadChildren: () => import('./acceptOwnership/accept-ownership/accept-ownership.module').then(m => m.AcceptOwnershipPageModule),
    canActivate: [AuthGuard],
    data: { claimType: 'CanAccessDashboardOwned' }
  },
  {
    path: 'devices/addfirstdevice',
    loadChildren: () => import('./guide-user/guide-user.module').then(m => m.GuideUserPageModule)
  },
  {
    path: 'shop/orderStatus/:orderNo',
    children: [
      {
        path: '',
        loadChildren: () => import('./shop/order-status/order-status.module').then(m => m.OrderStatusPageModule),
        // canActivate: [AuthGuard],
        data: { claimType: 'CanAccessGroupsOwned' }
      }
    ],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
  },
  {
    path: '', loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    resolve: { countries: CountriesResolver }
  },
  {
    path: 'guide-user',
    loadChildren: () => import('./guide-user/guide-user.module').then(m => m.GuideUserPageModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminPageModule)
  },
  {
    path: 'energy-insights-settings-create',
    loadChildren: () => import('./insights/energy-insights-settings-create/energy-insights-settings-create.module').then( m => m.EnergyInsightsSettingsCreatePageModule)
  },
  {
    /**
     * Convert a Cloud url to an app url.
     * The canActivate function will remove the production/# part from the url.
     * The component is never visited but the route requires a Component.
     * 
     * For example: /production/#/lqsSubscriptions becomes /lqsSubscriptions.
     * 
     * Reason: because of the # in the url the routes are never matched.
     */
    path: 'production',
    component: ProductionRedirectComponent,
    canActivate: [(
      _next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot) => {
      const router = inject(Router);
      const url = state.url;
      const newUrl = url.replace('production#/', '');
      return url === newUrl || router.parseUrl(newUrl);
    }],
  },
  {
    path: 'lqsSubscriptions',
    redirectTo: 'tabs/shop'
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
